import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomTooltip = ({ title, children, placement = "right" }) => {
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
      arrow
      placement={placement}
      {...props}
      classes={{ popper: className }}
    />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      // backgroundColor: '#f5f5f9',
      color: "#fff",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(11),
      border: "1px solid #dadde9",
      padding: "10px",
      fontFamily: "Montserrat",
    },
  }));

  return <HtmlTooltip title={title}>{children}</HtmlTooltip>;
};

export default CustomTooltip;
